/**
 * Shared smooth-scroll to on-page anchors (homepage CRO → #buy-bundle)
 */
(function (window, document) {
  'use strict';

  function headerOffset() {
    var header = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header, .section-header, header');
    if (!header) return 16;
    return Math.round(header.getBoundingClientRect().height) + 16;
  }

  function scrollToId(id) {
    if (!id) return false;
    var target = document.getElementById(id);
    if (!target) return false;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top, behavior: 'smooth' });
    if (history && history.replaceState) {
      history.replaceState(null, '', '#' + id);
    }
    return true;
  }

  function bind(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-hsh-scroll-target]').forEach(function (el) {
      if (el.getAttribute('data-hsh-scroll-bound') === '1') return;
      el.setAttribute('data-hsh-scroll-bound', '1');
      el.addEventListener('click', function (e) {
        var id = (el.getAttribute('data-hsh-scroll-target') || '').replace(/^#/, '').trim();
        if (!id) return;
        if (scrollToId(id)) e.preventDefault();
      });
    });
  }

  function boot() {
    bind(document);
    // Hash on load (e.g. /#buy-bundle)
    var hash = (window.location.hash || '').replace(/^#/, '');
    if (hash && document.getElementById(hash)) {
      setTimeout(function () {
        scrollToId(hash);
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    bind(document);
  });

  window.HshSmoothScroll = { to: scrollToId, bind: bind };
})(window, document);
